import { useStore } from '@nanostores/react';
import { lazy } from 'react';
import { ClientOnly } from 'remix-utils/client-only';
import { AuthButtons } from './AuthButtons';
import { BaseHeader } from './BaseHeader';
import { HeaderSocialLinks } from './HeaderSocialLinks';
import { MobileMainMenu } from './MobileMainMenu';
import { Navbar } from './Navbar';
import { ProjectInfo } from './ProjectInfo.client';
import { LazyLoadWrapper, retry } from '~/components/ui/LazyLoadWrapper';
import { chatStore } from '~/lib/stores/chat';
import { userStore } from '~/lib/stores/user';

const HeaderActionButtons = lazy(
  retry(() =>
    import('./HeaderActionButtons.client').then((module) => ({
      default: module.HeaderActionButtons,
    })),
  ),
);

const VersionHistoryButton = lazy(
  retry(() =>
    import('./VersionHistory.client').then((module) => ({
      default: module.VersionHistoryButton,
    })),
  ),
);

export function Header({ hidden }: { hidden?: boolean }) {
  const loggedIn = useStore(userStore.loggedIn);
  const chatStarted = useStore(chatStore.started);

  const logoChildren = chatStarted ? (
    <LazyLoadWrapper name="VersionHistoryButton">
      <VersionHistoryButton />
    </LazyLoadWrapper>
  ) : null;

  return (
    <BaseHeader hidden={hidden} border={chatStarted} logoChildren={logoChildren}>
      {chatStarted && (
        <div className="flex-1 select-text px-4 text-sm text-center text-bolt-elements-textPrimary">
          <ClientOnly>
            {() => (
              <div className="relative flex items-center justify-center gap-1.5">
                <ProjectInfo />
              </div>
            )}
          </ClientOnly>
        </div>
      )}

      {!chatStarted && <ClientOnly>{() => <Navbar className="hidden lg:flex" />}</ClientOnly>}

      <div className="flex grow-1 basis-60 justify-end items-center gap-3">
        <ClientOnly>
          {() => (
            <>
              {!chatStarted && <HeaderSocialLinks />}

              {!loggedIn && <AuthButtons className={chatStarted ? 'flex' : 'hidden lg:flex'} />}

              {!chatStarted && <MobileMainMenu />}

              {chatStarted && loggedIn && (
                <LazyLoadWrapper name="HeaderActionButtons">
                  <HeaderActionButtons />
                </LazyLoadWrapper>
              )}
            </>
          )}
        </ClientOnly>
      </div>
    </BaseHeader>
  );
}
